import { render } from "./JobsTable.vue?vue&type=template&id=3724148d"
import script from "./JobsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/JobsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3724148d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3724148d', __exports__)) {
    api.reload('3724148d', __exports__)
  }
  
  module.hot.accept("./JobsTable.vue?vue&type=template&id=3724148d", () => {
    api.rerender('3724148d', render)
  })

}


export default __exports__